<template>
  <router-view />
</template>

<!--<style scoped>-->
<!--@import "~bootstrap/dist/css/bootstrap.min.css";-->
<!--@import "~@fortawesome/fontawesome-free/css/all.css";-->
<!--@import "~@fortawesome/fontawesome-free/css/v4-shims.min.css";-->
<!--@import "~vue-material/dist/vue-material.css";-->
<!--@import "~vue-material/dist/theme/default.css";-->
<!--</style>-->

<!--<style scoped lang="scss">-->
<!--@import "@/assets/stylesheets/steps/form.scss";-->
<!--@import "@/assets/stylesheets/steps/partials.scss";-->
<!--@import "@/assets/stylesheets/social_calc/calc";-->
<!--@import "@/assets/stylesheets/custom";-->
<!--</style>-->

<script>
import { AUTH_LOGOUT } from "@/store/actions.type";
import store from "@/store";
import router from "@/router";

export default {
  created() {
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function(resolve, reject) {
        if (err.request.status === 401 && err.config && !err.config.__isRetryRequest) {
          store.dispatch(AUTH_LOGOUT);
          router.push("/not-authorized");
        }
        throw err;
      });
    });
  }
};
</script>
